import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

function createEditor(propsData) {
  return new Vue({
    ...App,
    propsData
  })
}

window.createEditor = createEditor;
